import { render, staticRenderFns } from "./ratio1.vue?vue&type=template&id=8d53d7ac&"
import script from "./ratio1.vue?vue&type=script&lang=js&"
export * from "./ratio1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports